export default __webpack_public_path__ + "static/media/left.3cc88230.svg";